import {
  canAssignCarrierFromStatus,
  assigningCarrierAdvancesStatus,
} from '../../manageLoadForm/constants';

export interface AssignCarrierPlan {
  eligible: any[];
  // PENDING loads have no warehouse/fee yet, so they can't take a carrier.
  skippedPending: any[];
}

export function planAssignCarrier(rows: any[]): AssignCarrierPlan {
  const eligible: any[] = [];
  const skippedPending: any[] = [];

  for (const row of rows || []) {
    if (canAssignCarrierFromStatus(row?.status)) eligible.push(row);
    else skippedPending.push(row);
  }

  return { eligible, skippedPending };
}

// Of the eligible loads, the ones where attaching a carrier IS the dispatch step
// (so advancing to ASSIGNED is correct); others only record the carrier.
export function advanceableLoads(rows: any[]): any[] {
  return (rows || []).filter((row) =>
    assigningCarrierAdvancesStatus(row?.status, Boolean(row?.cust?.requiresPrepay))
  );
}
